import {
    computeData,
    eventStringToObject,
    initConfig,
    initDisplayTracking,
    initTracking,
    sendEvent,
} from '@ma-js-common/wa-client';
import { captureException } from '@sentry/browser';
import $ from 'jquery';
import Cookies from 'js-cookie';
import urlJoin from 'url-join';

initConfig({
    receiverUrl: urlJoin(MA.Config.WEBANALYTICS_PARTNERS_URL, 'events'),
    appName: 'www',
    debug: MA.Config.WA_DEBUG,
    sentryCaptureException: captureException,
    apiKey: MA.Config.GATEWAY_API_KEY,
    useBeacon: false, // @TODO enable beacon and monitor with BI to see if events are lost
});

/**
 * Append global user ID to an existing WA event data
 *
 * @param {Object} waData
 * @returns {{user_id: *}|*}
 */
function appendUserId(waData) {
    return window.MA_USER && window.MA_USER.id
        ? {
              ...waData,
              user_id: window.MA_USER.id,
          }
        : waData;
}

/**
 * Append 'retargeting:' if utm_source is set to criteo
 *
 * @param {String} waSource
 */
function updateSourceWhenRetargeting(waSource) {
    if (Cookies.get('utm_source') === 'criteo') {
        return `retargeting:${waSource}`;
    }
    return waSource;
}

/**
 * Push a specific event to be sent to WebAnalytics API
 *
 * @param {String} eventKey
 * @param {String} eventName
 * @param {String|Object} eventData
 * @return {Promise}
 */
function push(eventKey, eventName, eventData) {
    const waData = typeof eventData === 'string' ? eventStringToObject(eventData) : eventData;
    return sendEvent({
        key: eventKey,
        name: eventName,
        data: appendUserId(waData),
    });
}

/**
 * Send display tracking for every visible html tag that has [data-wa-track=display] attribute
 *
 * @param {jQuery} $container
 * @param {Object} waData
 */
function setDisplayTracking($container = $('body'), waData = undefined) {
    initDisplayTracking($container[0], appendUserId(waData));
}

/**
 * Bind click tracking for every html tag that has [data-wa-track=click] attribute
 *
 * @param {jQuery} $container
 * @param {Object} waData
 */
function setClickTracking($container = $('body'), waData = undefined) {
    initTracking($container[0], appendUserId(waData));
}

/**
 * Bind click tracking a display tracking depending on [data-wa-track] attr value.
 *
 * @param {jQuery} $container
 * @param {Object} waData
 */
function setTracking($container = $('body'), waData = undefined) {
    setClickTracking($container, waData);
    setDisplayTracking($container, waData);
}

export default {
    push,
    setTracking,
    setClickTracking,
    setDisplayTracking,
    computeData,
    updateSourceWhenRetargeting,
};
